import Vue from 'vue'

function getStackTraceInfo() {
  try {
    throw new Error()
  } catch (e) {
    const stack = e.stack
    const frames = stack.split('\n')
    const regex = /\((.*):(\d+):(\d+)\)/
    for (const frame of frames) {
      const match = frame.match(regex)
      if (match) {
        const file = match[1]
        const line = parseInt(match[2], 10)
        const column = parseInt(match[3], 10)
        return {
          file,
          line,
          column,
          uniqueId: `${file}:${line}:${column}`,
        }
      }
    }
    return null
  }
}

Vue.use({
  install() {
    let scope = {}

    /**
     * On staging envs, collect calls and warn if a watcher is triggered more than N times within a second.
     * @param {*} warnIfCallsTimesWithinOneSec
     */
    Vue.prototype.$trackWatch = function trackWatch(
      warnIfCallsTimesWithinOneSec = 10
    ) {
      try {
        if (
          Vue?.prototype?.$env?.isProduction &&
          Vue?.prototype?.$env?.isProduction()
        ) {
          return
        }
        let obj = getStackTraceInfo()
        scope[obj.uniqueId] = scope[obj.uniqueId] || { ...obj, calls: 0 }
        if (scope[obj.uniqueId].calls === 0) {
          scope[obj.uniqueId].startDate = Date.now()
        }
        scope[obj.uniqueId].calls++
        if (Date.now() - scope[obj.uniqueId].startDate < 1000) {
          if (scope[obj.uniqueId].calls > warnIfCallsTimesWithinOneSec) {
            console.warn(
              `$trackWatch Vue watcher called ${
                scope[obj.uniqueId].calls
              } within 1s`,
              scope[obj.uniqueId]
            )
            scope[obj.uniqueId].calls = 0
          }
        }
      } catch (err) {
        console.warn({ details: 'watchTracker error', err })
      }
    }
  },
})
